export default {
  namespaced: true,
  state: {
    successMessage: '',
    successLabel: '',
  },
  mutations: {
    setSuccessMessage(state, message) {
      state.successMessage = message
    },
    setSuccessLabel(state, label) {
      state.successLabel = label
    },
  },
  getters: {
    successMessage: state => state.successMessage,
    successLabel: state => state.successLabel,
  }
}
